import axios from "axios";
import { Button } from "devextreme-react";
import { useCallback } from "react";
import { useSelector } from "react-redux";
import { hasPermission } from "../../../../utils/hasPermission";
import { PERM } from "../../../../utils/permissions";

export default function ProjectCompletionDateCell(props) {
  const { onClockRotateLeftIconClick, data, onCircleCheckIconClick } = props;

  const userInfo = useSelector((state) => state.userInfo);
  const canEditSales = hasPermission(userInfo.permissions, PERM.SALES_MGMT_EDIT);

  return (
    <>
      {canEditSales && (
        <Button
          icon="fa-solid fa-clock-rotate-left"
          style={{ float: "left", margin: 0, height: "20px" }}
          onClick={() => onClockRotateLeftIconClick(data.data)}
        />
      )}
      <div
        style={{
          marginTop: "5px",
          float: "left",
          // backgroundColor: "#FFE0E0",
        }}
      >
        {data.value}
      </div>
      {!canEditSales && data.data.reqConfirmProjComplDate == "Y" && (
        <Button
          id="circleCheckIcon"
          icon="fa-solid fa-circle-check"
          style={{
            float: "left",
            margin: 0,
            height: "20px",
            // backgroundColor: "rbg(255, 244, 244)",
          }}
          onClick={() => onCircleCheckIconClick(data.data)}
        />
      )}
    </>
  );
}
